import axios from 'axios';
import { req } from './axiosFun';
import { param } from 'jquery';


//询首页资讯
export const selectaddr = (params) => { return req("post", "/lbmaininfo/selectaddr", params) };

//根据首页资讯id查询首页资讯
export const lbmaininfoselectone = (params) => { return req("post", "/lbmaininfo/selectone", params) };

//查询团队
export const veteranselect = (params) => { return req("post", "/veteran/appselect", params) };

//查询图片
export const tupiansearch = (params) => { return req("post", "/tupian/appone", params) };

//查询案例
export const anlisearch = (params) => { return req("post", "/anli/appselect", params) };
//查询案例具体情况
export const anliselectone = (params) => { return req("post", "/anli/selectone", params) };
//查询工地直播列表
export const gongdizblist = (params) => { return req("post", "/gongdizb/appselect", params) };
//直播详情
export const gongdizbone = (params) => { return req("post", "/gongdizb/selectone", params) };

//客户点评
export const dqselect = (params) => { return req("post", "/dianping/select", params) };
// 案例分类
export const getClassData = (params) => { return req("post", "/anlitype/appselect", params) };
// 查询案例图片
export const getDataAnli = (params) => { return req("post", "/anli/appselect", params) };
// 查询公司信息
export const selectusetbyflag = (params) => { return req("get", "usesetting/selectusetbyflag/"+ params) };



// WEBPACK FOOTER //
// ./src/api/index.js